/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-03-28 15:40:39
 * @FilePath: src/store/modules/app.ts
 * @Description: TypeScript版本 - 自动转换
 */

import { defineStore } from 'pinia';

import Cookies from 'js-cookie'
import { setCookie } from '@/utils/cookie'

const useAppStore = defineStore(
  'app',
  {
    state: (): any => ({
      sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false,
        hide: false
      },
      device: 'desktop',
      size: Cookies.get('size') || 'default'
    }),
    actions: {
      toggleSideBar(withoutAnimation: any): void {
        if (this.sidebar.hide) {
          return false;
        }
        this.sidebar.opened = !this.sidebar.opened
        this.sidebar.withoutAnimation = withoutAnimation
        if (this.sidebar.opened) {
          setCookie('sidebarStatus', 1)
        } else {
          setCookie('sidebarStatus', 0)
        }
      },
      closeSideBar(withoutAnimation: any): void {
        setCookie('sidebarStatus', 0)
        this.sidebar.opened = false
        this.sidebar.withoutAnimation = withoutAnimation
      },
      toggleDevice(device: any): void {
        this.device = device
      },
      setSize(size: any): void {
        this.size = size;
        setCookie('size', size)
      },
      toggleSideBarHide(status: any): void {
        this.sidebar.hide = status
      }
    }
  })

export default useAppStore
